const trackingUtils = require('../utils/tracking.utils');
const deepLinkControllerDialog = require('./deeplink_details_controller_dialog');
const deepLinkControllerWaitingPage = require('./deeplink_details_controller_waiting_page');
const tripdetailsStorageUtils = require('../utils/tripdetails_storage.utils');
const xsellGlobalModel = require('od-modules/xsell/data/global_model');

const TRACKING_PAGE = '_confirmation_page_';
const TRACKING_CATEGORY = 'access_my_trip_details';
const TRACKING_SUCCESSFULL = 'automatic_redirection_successful';
const TRACKING_CATEGORY_FAILED = 'find_booking_error';
const TRACKING_EVENT_FAILED = 'access_my_trips_automatic_error';
const DEFAULT_TRACKING_PAGE = 'confirmed';
const BOOKING_INFO = 'bookingInfo';

const DeepLinkToDetailsController = function(isDp, widgetLoader, waitingElement) {
    this.automaticRedirectionStates = Object.freeze({
        NOT_ACTIVE: 0,
        INIT: 1,
        SUCCESSFUL: 2,
        FAILED: 3,
    });

    this.pageStatusTrackingNames = Object.freeze({
        BOOKING_CONFIRMED: 'confirmed',
        BOOKING_PENDING: 'pending',
    });

    this.pageStatus = DEFAULT_TRACKING_PAGE;

    this.automaticRedirectionStatus = this.automaticRedirectionStates.NOT_ACTIVE;

    this.flow = Odigeo._.isBoolean(isDp) && isDp ? 'dynpack' : 'flights';
    this.waitingElement = Odigeo._.get(waitingElement, 'name', 'dialog') === 'waitingPage' ?
        deepLinkControllerWaitingPage(waitingElement.waitingController) : deepLinkControllerDialog;

    this.requestBookingDetails = function(usersManager) {
        const myTrip = this._getTripData();
        const email = Odigeo._.get(myTrip, 'buyer.mail');
        const bookingId = Odigeo._.get(myTrip, 'bookingId');
        xsellGlobalModel.set('hasPrimeDiscount', Odigeo._.isPlainObject(myTrip.membershipPerksDTO));
        this.executeSubmitUserRequest(email, bookingId, usersManager);
        this.waitingElement.showLoading();
    };

    this.requestBookingDetailsWithConfirmationdata = function(usersManager, confirmationData) {
        this.automaticRedirectionStatus = this.automaticRedirectionStates.INIT;
        this.pageStatus = Odigeo._.get(this.pageStatusTrackingNames, confirmationData.bookingStatus, DEFAULT_TRACKING_PAGE);
        const email = Odigeo._.get(confirmationData, 'myTrip.buyer.mail');
        const bookingId = Odigeo._.get(confirmationData, 'myTrip.bookingId');
        xsellGlobalModel.set('hasPrimeDiscount', Odigeo._.isPlainObject(confirmationData.membershipPerksDTO));

        this.executeSubmitUserRequest(email, bookingId, usersManager);
    };

    this.executeSubmitUserRequest = (mail, bookingId, usersManager) => {
        usersManager().execute('submitUserRequest', {
            action: 'getTrip',
            data: {
                queryParams: {
                    email: mail,
                    bookingid: bookingId,
                }}});
    };

    this.goToMyTripsDetails = function(bookingDetails) {
        const isTablet = Odigeo.Device.isTablet() || Odigeo.Device.isIpad();
        this._saveBookingDetailsOnSession(bookingDetails);
        const isHotelPBCoSearchEnabled =
            !Odigeo.Utils.isRequestApp('dp') &&
            !Odigeo.Utils.isRequestApp('upsell') &&
            !isTablet;
        this.showFakeLoadingAndRedirect(isHotelPBCoSearchEnabled ? 15000 : 3000);
    };

    this.catchGetTripError = function() {
        this.waitingElement.closeLoading();
        this.waitingElement.showError();
    };

    this.showFakeLoadingAndRedirect = function(loadingTime) {
        if (waitingElement.name === 'waitingPage') {
            this.waitingElement.showLoading();
        }
        Odigeo._.delay(function() {
            this.waitingElement.closeLoading();
            this._deepLinkToDetails();
        }.bind(this), loadingTime);
    };

    this._deepLinkToDetails = function() {
        this._trackMyTripDetailsAccess();
        widgetLoader.get('login').execute('fromDeepLinkToDetails', this.flow);
    };

    this._trackMyTripDetailsAccess = function() {
        if (this.automaticRedirectionStatus === this.automaticRedirectionStates.SUCCESSFUL) {
            trackingUtils.trackEventWithCategory(this.flow +
                TRACKING_PAGE + this.pageStatus, TRACKING_CATEGORY, TRACKING_SUCCESSFULL);
        }
    };

    this._saveBookingDetailsOnSession = function(bookingDetails) {
        const bookingId = Odigeo._.get(bookingDetails, 'bookingBasicInfo.id');
        tripdetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO, bookingDetails);
        Odigeo.Session.set('tdid', bookingId);
        if (this.automaticRedirectionStatus === this.automaticRedirectionStates.SUCCESSFUL) {
            Odigeo.Session.set('isRedirectionFromConfirmation', bookingId);
        }
    };

    this._getTripData = function() {
        const myTripsData = Odigeo.Utils.parseJson(Odigeo.Session.get('mytripsData'));
        const myTrip = this._getLastBooking(myTripsData);

        return myTrip;
    };

    this._getLastBooking = function(myTripsData) {
        return Odigeo._.max(myTripsData, 'bookingId');
    };

    this.catchAutomaticRedirectionError = function() {
        this.automaticRedirectionStatus = this.automaticRedirectionStates.FAILED;
        trackingUtils.trackEventWithCategory(this.flow + TRACKING_PAGE + this.pageStatus,
            TRACKING_CATEGORY_FAILED, TRACKING_EVENT_FAILED);
    };
};

module.exports = DeepLinkToDetailsController;
